<template>
  <div class="Diallog">
    <el-dialog v-if="dialogVisible" :append-to-body="appendToBody" :with-header='withHeader' :title="title" :center="center" :visible.sync="dialogVisible" :width="widthDial" :close-on-click-modal="closeModal" :close-on-press-escape="closeEsc" @close='handleClose' :show-close="closeShow">
      <div slot="title" class="title_box" v-if="titleShow">
        <div :class="['title_name',HeaderPosition?'text_align_center':'text_align_left']"><span style="marginRight:10px">{{title}}</span><span style="fontSize:12px" class="color_red">{{Subtitle}}</span></div>
        <div class="title_line"></div>
      </div>
      <div class="diallogBody" :style="`height:${heightDial}px`">
        <slot></slot>
      </div>
      <div slot="footer" class="dialog-footer" v-if="footerShow">
        <el-button style="width:90px" size="mini" @click="close">取消</el-button>
        <el-button style="width:90px" size="mini" type="primary" v-preventReClick  @click="save">{{DetermineName}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      default: ''
    },
    HeaderPosition:{ //标题是否居中
      type:Boolean,
      default:false
    },
    appendToBody:{
      type:Boolean,
      default:false
    },
    titleShow:{
      type: Boolean,
      default:true
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '提示'
    },
     Subtitle: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean,
      default: false
    },
    widthDial: {
      type: String,
      default: '40%'
    },
     DetermineName: {
      type: String,
      default: '确定'
    },
    heightDial: {
      type: Number,
      default: 600
    },
    closeModal: {
      type: Boolean,
      default: false
    },
    closeEsc: {
      type: Boolean,
      default: false
    },
    closeShow: {
      type: Boolean,
      default: true
    },
    footerShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      handler: function (data) {
        this.dialogVisible = data
      }
    },
    dialogVisible: {
      immediate: true,
      handler: function (data) {
        this.$emit('input', data)
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    close() {
      this.$emit('colse')
      this.dialogVisible = false
    },
    save() {
      this.$emit('dialog')
    },
    handleClose(){
      this.$emit('CloseCallback')
    }
  }
}
</script>
<style lang='scss' scoped>
.Diallog {
  .diallogBody {
    width: 100%;
    overflow-y: auto;
  }
}
.title_box {
  .title_name {
    width: 100%;
    height: 53px;
    line-height: 53px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #000000;
  }
  .text_align_left{
    text-align: left;
  }
  .text_align_center{
    text-align: center;
  }
  .title_line {
    height: 1px;
    border: 1px solid #d5d5d5;
    background-color: #d5d5d5;
  }
}
/deep/ .el-dialog__body{
  padding:1px 15px 5px 15px;
}
/deep/ .el-dialog__header{
  padding: 10px;
}
.color_red {
  color: #e61d1d;
  cursor: pointer;
}
</style>
